import axios from 'axios';
import { getIdpTenantUrl } from './getIdpTenantUrl';

export default async function refreshCurrentSession(): Promise<void> {
  const axiosClient = axios.create({
    baseURL: getIdpTenantUrl(),
    withCredentials: true,
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete axiosClient.defaults.headers.common.authorization;
  await axiosClient.post<unknown>('/api/v1/sessions/me/lifecycle/refresh');
}
